/* globals data, serverParams */
import Table from 'bam-node-savant-table/table'
import { headers, secondaryHeaders } from './headers'

const { entity_code, is_team_type } = serverParams
const isLeague = entity_code === 'League'

const tableDivId = 'baserunning_run_value_table'

if (data && data.length) {
    loadTable(data)
}

function loadTable(data) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }
    const defaultSort = document.getElementById('sort').value
    const defaultSortDirection = document.getElementById('sortDir').value

    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        secondaryHeaders,
        headers,
        highlightFalsy: false,
        data,
        uniqueId: 'pitcher_id', // this can't have dashes in it
        defaultSort,
        defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = populateUrl(column, state)
            window.history.replaceState('', '', url)
        },
        subDataId: 'row_id',
        drawerAvailable: (row) => !isLeague && row.runner_moved > 0,
    })
}

function populateUrl(sortColumn, sortDirection) {
    const parameters = {
        game_type: document.getElementById('ddlGameType').value,
        season_start: document.getElementById('ddlSeasonStart').value,
        season_end: document.getElementById('ddlSeasonEnd').value,
        sortColumn: document.getElementById('sort').value,
        sortDirection: document.getElementById('sortDir').value,
        split: document.getElementById('ddlSplitYears').value,
        n: document.getElementById('ddlMinOpps').value,
        team: document.getElementById('ddlTeam').value,
        type: document.getElementById('ddlGroup').value,
        with_team_only: document.getElementById('with-team-only').checked
            ? 1
            : 0,
    }

    // Should we remove this?
    if (sortColumn) {
        parameters.sortColumn = sortColumn
        document.getElementById('sort').value = sortColumn
    }

    if (sortDirection) {
        parameters.sortDirection = sortDirection
        document.getElementById('sortDir').value = sortDirection
    }

    const urlParams = new URLSearchParams(parameters)

    return `${window.location.pathname}?${urlParams.toString()}`
}

document.getElementById('btn-update').addEventListener('click', () => {
    window.location = populateUrl()
})

document.getElementById('btn-csv').addEventListener('click', () => {
    window.location.href = window.location.search
        ? `${window.location.href}&csv=true`
        : `${window.location.href}?csv=true`
})

let isFixedHeaderShowing = false

window.addEventListener('scroll', () => {
    window.requestAnimationFrame(() => {
        checkHeaderPosition(tableDivId)
    })
})

function checkHeaderPosition(divId) {
    const $el = document.getElementById(divId)
    if (!$el) {
        return
    }
    const { top } = $el.getBoundingClientRect()
    const height = $el.querySelector(`table thead`).offsetHeight
    if (!isFixedHeaderShowing && top < 0) {
        isFixedHeaderShowing = true
        addStaticHeader(divId)
    } else if (isFixedHeaderShowing && top - height > 0) {
        document
            .querySelector(`#${divId} table thead`)
            .classList.remove('fixed-header')
        isFixedHeaderShowing = false
    }
}

/* eslint-disable no-param-reassign */
function addStaticHeader(divId) {
    const $table = document.getElementById(divId)
    const width = $table.offsetWidth

    if (width && width > 767) {
        // Set TH Width before applying fixed-header
        $table
            .querySelector('.default-table-row')
            .querySelectorAll('td')
            .forEach((el) => {
                el.style.width = `${el.offsetWidth}px`
            })

        $table
            .querySelector('.tr-component-row')
            .querySelectorAll('th')
            .forEach((el) => {
                el.style.width = `${el.offsetWidth}px`
            })

        document
            .querySelector(`#${divId} table thead`)
            .classList.add('fixed-header')
    }
}

function showWithTeam(value) {
    if (is_team_type) {
        return
    }

    const display = ['', 'split'].includes(value) ? 'none' : 'inline-flex'
    document.getElementById('with-team-only-wrapper').style.display = display
}

document.querySelectorAll('.form-control').forEach((el) => {
    el.addEventListener('change', (e) => {
        const id = el.getAttribute('id')
        const type = id.slice(3)
        const { selectedIndex } = e.target
        document.querySelector(`.label-change-${type}`).innerText =
            e.target.value === 'split'
                ? 'All - Split by Team'
                : e.target[selectedIndex].text

        if (type === 'Team') {
            showWithTeam(e.target.value)
        }
    })
})

let currentData = data.slice()
const $input = document.querySelector('.table-search')

function getFilteredData(search) {
    const normalized_search = search
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()

    return data.filter((d) => {
        const name = d.entity_name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        return name.includes(normalized_search)
    })
}

if (data && data.length) {
    loadTable(currentData)

    if ($input) {
        $input.addEventListener('input', (e) => {
            currentData = getFilteredData(e.target.value)
            loadTable(currentData)
        })
    }
}
